import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { AnnounceProvider } from "./components/announce";
import { installRejectionLogger } from "./components/rejections";
import { applyAgentMode } from "./lib/agent";
import "./styles.css";

const qc = new QueryClient({
  defaultOptions: { queries: { staleTime: 5_000, refetchOnWindowFocus: false, retry: 1 } },
});

installRejectionLogger();
applyAgentMode();
createRoot(document.getElementById("root") as HTMLElement).render(
  <StrictMode>
    <QueryClientProvider client={qc}>
      <AnnounceProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </AnnounceProvider>
    </QueryClientProvider>
  </StrictMode>,
);
